import { mapGetters, mapActions } from 'vuex'

const moduleName = 'paymententries'

export default {
  computed: {
    ...mapGetters(moduleName, {
      returnRoute: 'returnRoute',
      snapshots: 'snapshots',
      baseSnapshot: 'baseSnapshot',
      currentSnapshot: 'currentSnapshot',
      snapshotDiff: 'snapshotDiff',
      readOnlyView: 'readOnlyView'
    }),
    ...mapGetters(['licenceExpired'])
  },
  methods: {
    ...mapActions(moduleName, [
      'getStoreItem',
      'addStoreItem',
      'addStoreItemPaymentEntry',
      'getStoreItemPaymentEntry',
      'saveSnapshot',
      'clearSnapshots',
      'setReturnRoute',
      'setReadOnlyView'
    ]),
    ...mapActions('printpreview', { setPrintPreviewReturnRoute: 'setReturnRoute', addEmailer: 'addEmailer', removeEmailer: 'removeEmailer' }),
    ...mapActions('printpreview', { addReportParameters: 'addParameters', removeReportParameters: 'removeParameters' })
  }
}
